import { ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of, switchMap } from 'rxjs';

export function getDeepestActivatedRouteSnapshot(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot {
  let route = snapshot;
  while (route.firstChild) {
    route = route.firstChild;
  }
  return route;
}

export const getRouteParameterRecursively = (param: string, route: ActivatedRoute | null): Observable<string> => {
  if (!route) {
    return of('');
  }
  return route.params.pipe(
    switchMap((params) => {
      return params[param] ? of(params[param]) : getRouteParameterRecursively(param, route.parent);
    }),
  );
};
